import { useMutation, useQuery } from "@tanstack/react-query";
import { useTranslation } from "@privacy/translations";
import { DynamicGrid } from "../dynamicGrid";
import { DynamicForm } from "../dynamicForm";
import { Drawer } from "../shared/Drawer";
import { useNavigateWithQueryParams } from "../shared/navigateWithQueryParams";
import {
  assessmentFormStandardAnswersQueryOptions,
  assessmentsFormQueryOptions,
  updateStandardAnswersMutationOptions,
} from "./trustAPI";

export const StandardAnswersDrawer = () => {
  const { t } = useTranslation();
  const navigate = useNavigateWithQueryParams();
  const formQuery = useQuery(assessmentsFormQueryOptions());
  const standardAnswersQuery = useQuery(assessmentFormStandardAnswersQueryOptions());
  const updateStandardAnswersMutation = useMutation(updateStandardAnswersMutationOptions());

  return (
    <DynamicGrid.Drawer>
      {!formQuery.data || !standardAnswersQuery.data ? (
        <Drawer.Loading />
      ) : (
        <DynamicForm.Provider
          answers={standardAnswersQuery.data.answers}
          isSaving={updateStandardAnswersMutation.isPending}
          isSaveError={updateStandardAnswersMutation.isError}
          onSave={answerRequest => updateStandardAnswersMutation.mutateAsync([answerRequest])}
        >
          {({ formState }) => (
            <>
              <Drawer.Header
                title={t("Trust.StandardAnswers.DrawerTitle")}
                onClose={() => navigate("..")}
                status={DynamicForm.formStateToDrawerHeaderStatus(formState)}
                verticalPadding={1.4}
              />
              <Drawer.Content>
                <DynamicForm.InlineForm variant="secondary" id="standard-answers" form={formQuery.data} />
              </Drawer.Content>
            </>
          )}
        </DynamicForm.Provider>
      )}
    </DynamicGrid.Drawer>
  );
};
